export default __webpack_public_path__ + "static/media/news (3).a9b416c6.jpg";